import React, { useContext, useRef } from 'react';
import ReactApexChart from 'react-apexcharts';
import DashboardContainer from '../../DashboardContainer';
import { downloadCSV } from '../../DashboardFunctions/ExportApexFunction';
import { ApplicationContext } from '../../../../../Context/DashbaordContext';
import { useFetchSourceOfConnection } from '../../../../../Hooks/Dashboard';

const SourceChannels = () => {
  const chartRef = useRef(null);

  const { date, setDate, applicationStart } = useContext(ApplicationContext);
  const { data, isLoading } = useFetchSourceOfConnection({
    startDate: date.startDate,
    endDate: date.endDate,
    applicationStart: applicationStart,
  });

  const chartData = {
    series: [
      {
        name: 'Value',
        data: data?.data?.map((i) => i.value) || [],
      },
    ],
    options: {
      chart: {
        height: '100%',
        type: 'line',
        zoom: { enabled: false },
        toolbar: { show: true },
      },
      dataLabels: { enabled: false },
      stroke: { curve: 'smooth', width: 4, colors: ['#0500FA'] },
      fill: { opacity: 1 },
      xaxis: {
        categories: data?.data?.map((i) => i.label) || [],
        labels: {
          style: { colors: '#1b224c', fontWeight: 400, fontSize: '12px' },
        },
      },
      yaxis: {
        labels: {
          style: { colors: '#1b224c', fontWeight: 400, fontSize: '12px' },
        },
      },
      grid: {
        borderColor: '#e0e0e0',
        row: { colors: ['#F3F8FF', '#FFFFFF'], opacity: 1 },
      },
      markers: {
        size: 6,
        colors: ['#0500FA'],
        strokeWidth: 0,
        shape: 'rect',
        customSVG: { path: '<rect x="0" y="0" width="15" height="15" />' },
        hover: { size: 10 },
      },
      tooltip: { enabled: true },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { height: '100%' },
            xaxis: { labels: { style: { fontSize: '8px' } } },
            yaxis: { labels: { style: { fontSize: '8px' } } },
            markers: { size: 3, hover: { size: 6 } },
          },
        },
      ],
    },
  };
  console.log('FVDsvvs', chartData);
  const handleDownload = () => {
    if (!data?.data?.length) return;

    const title = 'SourceChannels_Graph';

    const series = data.data.map((i) => i.value);
    const categories = data.data.map((i) => i.label);

    downloadCSV(series, categories, title);
  };

  return (
    <DashboardContainer
      title='Source from different Channels'
      handleExport={handleDownload}
      chartRef={chartRef}
      noData={data?.data?.length == 0}
    >
      <div ref={chartRef}>
        <ReactApexChart
          options={chartData?.options}
          series={chartData?.series}
          type='line'
          height='400'
        />
      </div>
    </DashboardContainer>
  );
};

export default SourceChannels;
